// A TableAction is an abstract implementation for a bulk multi-edit action
// performed on a table's dataset.
export default class TableAction {
  id;

  label;

  hidden;

  // Called when this action is 'clicked'. This is any initiator to begin the operation.
  static doOpen = ({ column, editRows, setCurrentlyEditing, setCurrentEditor }) => {
    setCurrentEditor(column);
    setCurrentlyEditing(editRows);
  };

  // Called when this action is canceled or closed.
  static doClose = ({ setCurrentlyEditing, setCurrentEditor }) => {
    setCurrentEditor({});
    setCurrentlyEditing([]);
  };

  // Called when this action is canceled or closed.
  static defaultDisabled = (selections) => selections.length <= 0;

  // This is intended to be used by providing in the relevant callback overrides
  // which will be called by the data table at appropriate times.
  constructor({ id, label, doSave, disabled, hidden = false }) {
    this.id = id;
    this.label = label;
    this.hidden = hidden;
    this.doOpen = TableAction.doOpen;
    this.doClose = TableAction.doClose;
    this.disabled = disabled ?? TableAction.defaultDisabled;
    if (doSave) this.doSave = doSave;
  }
}
